import { PRODUCT_REVIEWS_STATE } from '../Actions/ProductReviews.action';

const DEFAULT_STATE = {
    visible: false,
};

export const productReviews = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case PRODUCT_REVIEWS_STATE:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}